import { ItemizedReceiptSentActivity } from "../types";
import { combinedRoles } from "../constants";
import { ApplicantType } from "shared/types";
import { getFullName } from "shared/utils/get-full-name";

export const ItemizedReceiptSent = ({
  activity
}: {
  activity: ItemizedReceiptSentActivity;
}) => {
  const contact = activity.details.contact;
  const name = contact
    ? getFullName({
        firstName: contact.first_name,
        lastName: contact.last_name,
        middleName: contact.middle_name,
        short: true
      })
    : "";
  const roleLabel = contact?.role ? combinedRoles[contact.role] : "";
  const article = contact?.role === ApplicantType.CoSigner ? "a" : "an";

  return name ? (
    <p className="text-sm font-normal text-content-400">
      {name}
      {roleLabel && (
        <>
          {" "}
          ({article} <span className="lowercase">{roleLabel}</span>)
        </>
      )}{" "}
      was emailed an itemized receipt
    </p>
  ) : null;
};
